import * as React from 'react';
import * as Theme from '@sail/theme-classic';
import {css} from '../css';
import {view} from '../view';

const styles = css({
  '--divider-style': css.value('1px solid $color.neutral150'),
  // note that outside of a stack layout (i.e. --when-flex-y not defined),
  // `borderTop` should apply as the fallback (via the empty space fallback value)
  borderTop: css.value('var(--when-flex-y,  ) var(--divider-style)'),
  borderLeft: css.value('var(--when-flex-x) var(--divider-style)'),
  display: css.value('block'),
  // make sure the divider only takes up the height or width as needed based on the stack direction
  width: css.value('var(--when-flex-x) 1px'),
  height: css.value('var(--when-flex-y) 1px'),
  // grow to fill the available space (capped above to 1px on the main axis)
  alignSelfX: 'stretch',
  alignSelfY: 'stretch',
});

/**
 * @external
 */
export const Divider = view.span.create((props, View) => {
  return <View uses={[styles, Theme.Divider, props]} role="separator" />;
});
